// react import
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
// landmineBoard = { reveal: false || true, mine : false || true,  }

// landmine:{
//     landmineBoard:{
//         "1x1":{},"1x2":{},...,
//     },
//     boardSize : 10 || 30,
//          landmineUsers:[{userId,nickname,end:boolean}]
//          turnUser:{},
//          gameStatus: false||true,
//          winner : {},
//          mineCount : number || 1
// }

// 턴이 아닐때  배경색 #E7E7E7 + hover 효과 삭제

const LandminePage = () => {
  const {
    landmine: {
      landmineBoard,
      landmineUsers,
      boardSize,
      turnUser,
      end,
      mineCount,
    },
    roomId,
  } = useSelector(state => state.GameSlice);
  const { userId, nickname } = useSelector(state => state.LoginInfoSlice);

  const landmineCells = useMemo(() => {
    const boards = [];

    for (let i = 1; i < boardSize * boardSize + 1; i++) {
      const row = Math.ceil(i / boardSize);
      const column = i % boardSize || 10;
      const location = `${row}x${column}`;
      const item = landmineBoard[location];
      const reveal = item?.reveal;
      const mine = item?.mine;
      const checkTurn = userId === turnUser?.userId;

      const clickHandler = () => {
        if (checkTurn && !end) {
          let updateUsers = [];

          landmineUsers.forEach(i => {
            updateUsers.push({ ...i });
          });

          const findIndex = updateUsers.findIndex(i => i?.userId === userId);
          const nextUser = updateUsers[findIndex + 1] || updateUsers[0];
          if (mine) {
            updateUsers[findIndex].end = true;
          }

          const gameEnd =
            updateUsers.filter(i => i.end).length === updateUsers.length - 1;
          const docRef = doc(db, "game", `room${roomId}`);
          const dbKey = "landmine.landmineBoard." + location;

          updateDoc(docRef, {
            [dbKey]: { reveal: true, userId, nickname, mine },
            "landmine.turnUser": nextUser,
            "landmine.landmineUsers": updateUsers,
            "landmine.end": gameEnd,
          });
        }
      };
      boards.push(
        <LandmineCell
          $reveal={reveal}
          $checkTurn={checkTurn}
          $size={boardSize}
          onClick={clickHandler}>
          {item?.mine && (reveal || end) ? "*" : ""}
        </LandmineCell>
      );
    }
    return boards;
  }, [
    landmineBoard,
    boardSize,
    turnUser,
    userId,
    end,
    landmineUsers,
    roomId,
    nickname,
  ]);

  const focusStyle = {
    backgroundColor: "#E7F1EC",
    border: "1px solid #137e43",
  };

  return (
    <Wrap>
      <MineContainer>{landmineCells}</MineContainer>
      <UserContainer>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(item => (
          <UserCell
            style={
              landmineUsers?.[item] &&
              turnUser.userId === landmineUsers?.[item]?.userId
                ? focusStyle
                : landmineUsers?.[item] && landmineUsers?.[item]?.end
                ? { backgroundColor: "#f5f5f5" }
                : null
            }>
            {landmineUsers?.[item] ? landmineUsers[item]?.nickname : ""}
            {item === 8 ? "지뢰 : " : ""}
            {item === 9 ? `${mineCount}개` : ""}
          </UserCell>
        ))}
      </UserContainer>
    </Wrap>
  );
};

export default LandminePage;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  /* left: 0;
  top: 0; */
  display: flex;
  flex-direction: column;
  /* position: absolute; */
  border-left: 1px solid #e0e0e0;
`;

const MineContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  display: flex;
`;
const UserContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 21px;
`;

const UserCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  height: 100%;
  font-size: 12px;
  color: #242424;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
`;

const LandmineCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  ${({ $size }) => `width: ${100 / $size}%;height: ${100 / $size}%;`}

  background-color: ${({ $reveal }) => ($reveal ? "#F5F5F5" : "#fff")};

  ${({ $checkTurn }) => $checkTurn && "cursor:pointer; &:hover{opacity:0.8}"}
`;
